<div class="h-h">
  <div>
    <mn-svg data-ui-sound mnClickArea class="c-p cu-p" name="arrow" mnAnalyticsClick="back_sidebar_info" (click)="close($event, true)" />
    <b class="t-h u-c">{{ type() + ".rules" | mnTranslate }}</b>
  </div>
  <mn-button aEvent="info_close" (clicked)="close($event, false)">
    <mn-svg name="close" />
  </mn-button>
</div>
@if (aA()) {
  <div #aE class="articles cu-p g-4">
    @for (article of ars(); track $index) {
      <div
        data-ui-sound
        #tabEl
        class="article t-r u-c"
        [mnAnalyticsClick]="'info_article_' + article.text"
        [class.active]="article === aA()"
        (click)="select(article, tabEl)">
        {{ article.text }}
      </div>
    }
  </div>
}
<div #cE class="o-y-a f-c g-16">
  @switch (type()) {
    @case (I_T.R) {
      <b data-article class="t-r">{{ "rules.text-1.title" | mnTranslate }}</b>
      <span class="t-s c-se">{{ "rules.text-1.msg.1" | mnTranslate }}</span>
      <span class="t-s c-se">{{ "rules.text-1.msg.2" | mnTranslate }}</span>
      <span class="t-s c-se">{{ "rules.text-1.msg.3" | mnTranslate }}</span>

      <b data-article class="t-r">{{ "rules.text-2.title" | mnTranslate }}</b>
      <span class="t-s c-se">{{ "rules.text-2.msg.1" | mnTranslate: { max_multiplier: mult() } }}</span>

      <b data-article class="t-r">{{ "rules.text-3.title" | mnTranslate }}</b>
      <span class="t-s c-se">{{ "rules.text-3.msg.1" | mnTranslate: { rtp: rtp() } }}</span>

      <b data-article class="t-r">{{ "rules.text-4.title" | mnTranslate }}</b>
      <div class="f-c g-4 t-s c-se">
        <span class="m-we c-p">{{ "rules.text-4.note" | mnTranslate }}</span>
        <span>{{ "rules.text-4.msg.1" | mnTranslate }}</span>
        <span>{{ "rules.text-4.msg.2" | mnTranslate }}</span>
        <span>{{ "rules.text-4.msg.3" | mnTranslate }}</span>
        <span>{{ "rules.text-4.msg.4" | mnTranslate }}</span>
        <span>{{ "rules.text-4.msg.5" | mnTranslate }}</span>
      </div>

      <b data-article class="t-r">{{ "rules.text-5.title" | mnTranslate }}</b>
      <span class="t-s m-we c-p">{{ "rules.text-5.note" | mnTranslate }}</span>
      <div class="f-c g-4 t-s c-se">
        <span>{{ "rules.text-5.msg.1" | mnTranslate }}</span>
        <span>{{ "rules.text-5.msg.2" | mnTranslate }}</span>
      </div>
    }
    @case (I_T.H) {
      <ng-template
        [ngTemplateOutlet]="counterItem"
        [ngTemplateOutletContext]="{ index: 1, title: 'how-to-play.text-1.title', msg: 'how-to-play.text-1.msg' }" />
      <img alt="tutorial" width="100%" src="/assets/images/webp/how-to-play/set-risk-sidebar.webp" />
      <ng-template
        [ngTemplateOutlet]="counterItem"
        [ngTemplateOutletContext]="{ index: 2, title: 'how-to-play.text-2.title', msg: 'how-to-play.text-2.msg' }" />
      <img alt="tutorial" width="100%" src="/assets/images/webp/how-to-play/drop-ball-sidebar.webp" />
      <ng-template
        [ngTemplateOutlet]="counterItem"
        [ngTemplateOutletContext]="{ index: 3, title: 'how-to-play.text-3.title', msg: 'how-to-play.text-3.msg' }" />
      <img alt="tutorial" width="100%" src="/assets/images/webp/how-to-play/win-sidebar.webp" />
    }
    @case (I_T.F) {
      <b data-article class="t-r">{{ "provably-fair.text-1.title" | mnTranslate }}</b>
      <span class="t-s c-se">{{ "provably-fair.text-1.msg" | mnTranslate: { game: ("game.name" | mnTranslate) } }}</span>

      <b data-article class="t-r">{{ "provably-fair.text-2.title" | mnTranslate }}</b>
      <span class="t-s c-se">{{ "provably-fair.text-2.msg" | mnTranslate: { game: ("game.name" | mnTranslate) } }}</span>

      <b data-article class="t-r">{{ "provably-fair.text-3.title" | mnTranslate }}</b>
      <span class="t-s c-se">{{ "provably-fair.text-3.msg" | mnTranslate }}</span>

      <b data-article class="t-r">{{ "provably-fair.text-4.title" | mnTranslate }}</b>
      <span class="t-s c-se">{{ "provably-fair.text-4.msg" | mnTranslate }}</span>
      <img alt="provably fair" width="100%" height="248" src="/assets/images/webp/common/provably-fair.webp" />

      <b data-article class="t-r">{{ "provably-fair.text-5.title" | mnTranslate }}</b>
      <div class="t-s c-se f-c g-4">
        <span>{{ "provably-fair.text-5.msg.1" | mnTranslate }}</span>
        <span>{{ "provably-fair.text-5.msg.2" | mnTranslate }}</span>
        <span>{{ "provably-fair.text-5.msg.3" | mnTranslate }}</span>
        <span>{{ "provably-fair.text-5.msg.4" | mnTranslate }}</span>
      </div>
      <span class="t-s c-se">
        {{ "provably-fair.text-5.msg.5" | mnTranslate }}
        <a class="t-s c-b" href="https://miniwebtool.com/sha256-hash-generator/" target="_blank"
          >https://miniwebtool.com/sha256-hash-generator/</a
        >
      </span>
    }
  }
</div>

<ng-template #counterItem let-title="title" let-index="index" let-msg="msg">
  <div class="g-12">
    <b class="counter t-r">{{ index }}</b>
    <div class="f-c t-s g-4">
      <strong class="u-c">{{ title | mnTranslate }}</strong>
      <span class="c-se">{{ msg | mnTranslate }}</span>
    </div>
  </div>
</ng-template>
